
import template from './ko-field-view-date.html';

class DateComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		this.formatted_value = ko.pureComputed(() => {
			let val = this.value();
			if (val == null || val === '') return '';
			let format_options = this.params?.options?.format || 'YYYY/MM/DD';
			let m = moment(val);
			return m.isValid() ? m.format(format_options) : '';
		});
	}
}


export default {
	name: 'ko-field-view-date',
	viewModel: DateComponentVM,
	module_type: 'ko',
	template: template
}
